webpackJsonp([174602474983118],{

/***/ 1331:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"VisitItemType","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"CLINICAL_NOTE"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"CONVERSATION"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"ENCOUNTER"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"LAB_RESULT"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"MEDICATION"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"PATIENT_DOCUMENT"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"REMINDER_SILENCE"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"TASK"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"TREATMENT_SHEET"}],"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---enum-visit-item-type-e11917ea4302eec67eeb.js